import {xy, xyz} from "./canvasTypes";
import {convert3dTo2d} from "./mathConverter";

// note ref
// https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fill
// https://developer.mozilla.org/en-US/docs/Web/API/Path2D

type fillStyleType = string | CanvasGradient | CanvasPattern

export function squareAroundCenter (ctx:CanvasRenderingContext2D, center:xy|xyz, color?:fillStyleType):void{
    let spot:xy;
    let size:number = 10
    if(center.length>2){
        spot = convert3dTo2d(center as xyz)
    }else{
        spot = center as xy
    }
    if(color){
        ctx.fillStyle = color
        ctx.fillRect((spot[0]-(size/2)),(spot[1]-(size/2)),size,size)
    }else{
        ctx.strokeRect(spot[0]-(size/2),(spot[1]-(size/2)),size,size)
    }
}

export function cubeOutline (ctx:CanvasRenderingContext2D ):void{
    let p = new Path2D();

    // outline points:
    p.moveTo( ...convert3dTo2d([0,0,255]))
    p.lineTo( ...convert3dTo2d([255,0,255]))
    p.lineTo( ...convert3dTo2d([255,0,0]))
    p.lineTo( ...convert3dTo2d([255,255,0]))
    p.lineTo( ...convert3dTo2d([0,255,0]))
    p.lineTo( ...convert3dTo2d([0,255,255]))
    p.closePath()

    ctx.strokeStyle="black"
    ctx.stroke(p)
}


function  makePlane ([p1,p2,p3,p4]:[p1:xy,p2:xy,p3:xy,p4:xy]){
    let p = new Path2D();
    p.moveTo(...p1)
    p.lineTo(...p2)
    p.lineTo(...p3)
    p.lineTo(...p4)
    p.closePath()
    return p
}

export function makeSplit3DPlane (ctx:CanvasRenderingContext2D, center:xyz, fixed:'x'|'y'|'z') {
    let [x,y,z] = center;
    let centerConverted:xy = convert3dTo2d(center)

    // convert here on points to convert once
    let start:xy;
    let topMid:xy;
    let topCorner:xy;
    let rightMid:xy;
    let rightCorner:xy;
    let bottomMid:xy;
    let bottomCorner:xy;
    let leftMid:xy;

    switch (fixed){ // todo find a better way than a switch?
        case "y":
            start =        convert3dTo2d([0,y,0])
            topMid =       convert3dTo2d([x,y,0])
            topCorner =    convert3dTo2d([256,y,0])
            rightMid =     convert3dTo2d([256,y,z])
            rightCorner =  convert3dTo2d([256,y,256])
            bottomMid =    convert3dTo2d([x,y,256])
            bottomCorner = convert3dTo2d([0,y,256])
            leftMid =      convert3dTo2d([0,y,z])
            break;
        case "x":
            start =        convert3dTo2d([x,0,0])
            topMid =       convert3dTo2d([x,y,0])
            topCorner =    convert3dTo2d([x,256,0])
            rightMid =     convert3dTo2d([x,256,z])
            rightCorner =  convert3dTo2d([x,256,256])
            bottomMid =    convert3dTo2d([x,y,256])
            bottomCorner = convert3dTo2d([x,0,256])
            leftMid =      convert3dTo2d([x,0,z])
            break;
        case "z":
            start =        convert3dTo2d([0,0,z])
            topMid =       convert3dTo2d([0,y,z])
            topCorner =    convert3dTo2d([0,256,z])
            rightMid =     convert3dTo2d([x,256,z])
            rightCorner =  convert3dTo2d([256,256,z])
            bottomMid =    convert3dTo2d([256,y,z])
            bottomCorner = convert3dTo2d([256,0,z])
            leftMid =      convert3dTo2d([x,0,z])
            break;
        default:
            throw new Error("Don't get here")
    }

    // top left quad // layer 3
    ctx.stroke(makePlane([
        start,        topMid,        centerConverted,        leftMid
    ]))
    // top right quad // layer 2
    ctx.stroke(makePlane([
        topMid,        topCorner,        rightMid,        centerConverted
    ]))
    // bottom right quad // layer 1
    ctx.stroke(makePlane([
        centerConverted,        rightMid,        rightCorner,        bottomMid
    ]))
    // bottom left quad // layer 2
    ctx.stroke(makePlane([
        leftMid,        centerConverted,        bottomMid,        bottomCorner
    ]))
    // todo color planes

}
